import { eq } from 'ember-truth-helpers';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import VideoEmbed from '../video-embed';

const plusOne = (idx) => {
  return idx + 1;
};

export default class RoundTabsComponent extends Component {
  get currentVideo() {
    // why do this over just passing the round itself in?
    // Guard against empty/short rounds arrays (real backend data can have a
    // final match with no rounds); VideoEmbed tolerates an empty src.
    return this.args.rounds?.[this.args.currentRound]?.embedUrl ?? '';
  }
  <template>
    <div class='tab-wrap'>
      <div class='tab-header items-{{@totalRounds}}'>
        {{#each @rounds as |round index|}}
          <div
            class='tab-header-item {{if (eq index @currentRound) "selected"}}'
            {{on 'click' (fn @selectRound index)}}
          >
            <p class='tab-header-item-text'>Round {{plusOne index}}</p>
          </div>
        {{/each}}
      </div>
    </div>
    <br />
    <VideoEmbed @src={{this.currentVideo}} @size='huge' @title='Round video' width='500' />
  </template>
}
